import { ComponentLoader } from '@bythepixel/component-loader';
import LocationSearch from '@Core/components/locationSearch';

const SearchComponent = [
  LocationSearch,
  {
    lazyLoad: true,
    mapOnly: true,
  },
];

window.LocationSearch = new ComponentLoader(document, [SearchComponent]);
